module.exports = __webpack_public_path__ + "img/head.dee32aec.png";